/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1PecegepayBilletCoursefinpersonpaymentidOrder200,
  GetApiV1PecegepayBilletCoursefinpersonpaymentidOrder401,
  GetApiV1PecegepayBilletCoursefinpersonpaymentidOrder404,
  GetApiV1PecegepayBilletCoursefinpersonpaymentidOrder500,
  GetApiV1PecegepayBilletCoursefinpersonpaymentidOrderPathParams,
  GetApiV1PecegepayBilletCoursefinpersonpaymentidOrderQueryResponse,
} from "../../types/pecegePayBilletController/GetApiV1PecegepayBilletCoursefinpersonpaymentidOrder.ts";
import { billetOrderResponseViewModelSchema } from "../billetOrderResponseViewModelSchema.ts";

export const getApiV1PecegepayBilletCoursefinpersonpaymentidOrderPathParamsSchema =
  z.object({
    courseFinPersonPaymentId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1PecegepayBilletCoursefinpersonpaymentidOrderPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1PecegepayBilletCoursefinpersonpaymentidOrder200Schema =
  z.lazy(
    () => billetOrderResponseViewModelSchema,
  ) as unknown as ToZod<GetApiV1PecegepayBilletCoursefinpersonpaymentidOrder200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1PecegepayBilletCoursefinpersonpaymentidOrder401Schema =
  z.any() as unknown as ToZod<GetApiV1PecegepayBilletCoursefinpersonpaymentidOrder401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1PecegepayBilletCoursefinpersonpaymentidOrder404Schema =
  z.any() as unknown as ToZod<GetApiV1PecegepayBilletCoursefinpersonpaymentidOrder404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1PecegepayBilletCoursefinpersonpaymentidOrder500Schema =
  z.any() as unknown as ToZod<GetApiV1PecegepayBilletCoursefinpersonpaymentidOrder500>;

export const getApiV1PecegepayBilletCoursefinpersonpaymentidOrderQueryResponseSchema =
  z.lazy(
    () => getApiV1PecegepayBilletCoursefinpersonpaymentidOrder200Schema,
  ) as unknown as ToZod<GetApiV1PecegepayBilletCoursefinpersonpaymentidOrderQueryResponse>;
